import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  Input,
} from "@angular/core";
import { NgSelectComponent } from "@ng-select/ng-select";
import { concat, merge, Observable, of, Subject } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  mapTo,
  switchMap,
  tap,
  filter,
} from "rxjs/operators";
import {
  DataService,
  ProductSelectorSearchQuery,
  SharedModule,
  LogicalOperator,
} from "@bb-vendure/admin-ui/core";
import {
  FreeGiftsDocument,
  SortOrder,
} from "../../../generated-graphql/graphql";
// import { FreeGiftsDocument } from "../generated-graphql"

@Component({
  selector: "gift-selector",
  templateUrl: "./gift-selector.component.html",
  styleUrls: ["./gift-selector.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule],
})
export default class GiftSelectorComponent implements OnInit {
  searchInput$ = new Subject<string>();
  searchLoading = false;
  searchResults$: Observable<any>;
  @Output() productSelected = new EventEmitter<
    ProductSelectorSearchQuery["search"]["items"][number]
  >();

  @Input() productRetailer: string;
  @Input() productArtist: string;
  @Input() selected: any;

  @ViewChild("autoComplete", { static: true })
  private ngSelect: NgSelectComponent;
  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.initSearchResults();
    this.searchResults$.subscribe((r) => console.log("gifts", r));
  }

  private initSearchResults() {
    const searchItems$ = this.searchInput$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap(() => (this.searchLoading = true)),
      switchMap((term) => {
        if (!term) {
          return this.dataService
            .query(FreeGiftsDocument, {
              options: {
                take: 5,
                sort: {
                  createdAt: SortOrder.Desc,
                },
              },
              retailerId: this.productRetailer,
              artistId: this.productArtist,
            })
            .mapSingle((result) => {
              const resultList = result.freeGifts.items;
              return resultList;
            });
        }
        return this.dataService
          .query(FreeGiftsDocument, {
            options: {
              filter: {
                name: {
                  contains: term,
                },
                sku: {
                  contains: term,
                },

                // supplier: {
                //   eq: this.productRetailer
                // }
              },
              //@ts-ignore
              filterOperator: LogicalOperator.OR,
            },
            retailerId: this.productRetailer,
            artistId: this.productArtist,
          })
          .mapSingle((result) => {
            const resultList = result.freeGifts.items;
            return resultList;
          });
      }),
      tap(() => (this.searchLoading = false))
    );

    const clear$ = this.productSelected.pipe(mapTo([]));
    this.searchResults$ = concat(
      this.dataService
        .query(FreeGiftsDocument, {
          options: {
            take: 5,
            sort: {
              createdAt: SortOrder.Desc,
            },
          },
          retailerId: this.productRetailer,
          artistId: this.productArtist,
        })
        .single$.pipe(
          switchMap((data) => {
            return of(data.freeGifts.items);
          })
        ),
      merge(searchItems$, clear$)
    );
  }

  selectResult(product?: any) {
    if (product) {
      this.productSelected.emit(product);
      this.ngSelect.clearModel();
      this.initSearchResults()
    }
  }
}
